<div
  class="container-fluid d-flex flex-row justify-content-center mb-0 mt-1 pt-0 pt-md-5 pt-xl-2 pb-4 shadow-lg col-xs-12 col-lg-8"
>
  <div class="jumbotron-fluid col-12 col-sm-8 col-md-7 col-xl-6">
    <div class="container my-2 mx-0 shadow-lg col-12">
      <div class="row">
        <div class="col-12">
          <h3
            class="rub-head4 text-info text-center font-weight-bold py-1"
          >
            Interest Rate(%)
          </h3>
        </div>
      </div>
    </div>
    <div class="invest-card card-body mt-2 pt-3 mb-0 mx-auto pb-2 shadow-lg">
      <form [formGroup]="userForm" (ngSubmit)="setInterestRate()">
        <div>
          <div class="form-group text-primary">
            <label for="loanType">Loan Type</label>
            <div class="input-group mb-0">
              <input
                type="radio"
                value="Boda Loan"
                formControlName="loanType"
                checked
                required
                (change)="checkLoanType(fval.loanType.value)"
              />&nbsp; Boda Loan &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <input
                type="radio"
                value="Taxi Loan"
                formControlName="loanType"
                required
                (change)="checkLoanType(fval.loanType.value)"
              />&nbsp; Taxi Loan &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <input
                type="radio"
                value="Micro Loan"
                formControlName="loanType"
                required
                (change)="checkLoanType(fval.loanType.value)"
              />&nbsp; Micro Loan
            </div>
            <div
              class="text-danger col"
              *ngIf="
                (fval.loanType.touched || fval.loanType.dirty) &&
                fval.loanType.errors?.required
              "
            >
              The Loan type is required!
            </div>
          </div>

          <div class="d-flex mt-0 mb-2 py-0 mx-auto">
            <div
              *ngIf="checkedClient"
              class="row"
            >
              <div class="col-12 text-left text-info h6"><strong>Selected Client Details</strong></div>
              <div class="col-6">ID: <strong>{{checkedClient.customerId}} </strong></div>
              <div class="col-6">Name: <strong>{{checkedClient.customerName}} </strong></div>
              <div class="col-6">Phone: <strong>{{checkedClient.customerPhone1}}</strong></div>
              <div class="col-6">Secret Pin: <strong>{{checkedClient.customerSecretPin}}</strong></div>
            </div>
          </div>
          <div class="d-flex mt-0 mb-2 py-0 mx-auto">
            <button
              (click)="selectFromData(dataModal, 100)"
              class="btn btn-info col-5 mx-auto"
              type="button"
              [disabled]="!fval.loanType.value"
            >
              Select Client
            </button>
            <button
              (click)="getStatement(template)"
              [disabled]="!checkedClient?.customerId"
              class="btn btn-info col-5 mx-auto"
              type="button"
            >
              Client's statement
            </button>
          </div>
  

        <div class="form-group text-primary">
          <label
            for="itemRate"
            [ngClass]="fval.itemRate.valid ? 'text-info' : ''"
            >Rate<i *ngIf="fval.itemRate.valid" class="material-icons"
              >check_circle</i
            ></label
          >
          <div class="input-group mb-0">
            <input
              id="itemRate"
              formControlName="itemRate"
              type="number"
              class="level-control form-control mx-0"
              placeholder="Set loan rate"
              [ngClass]="{
                'is-invalid':
                  (fval.itemRate.touched || fval.itemRate.dirty) &&
                  fval.itemRate.errors
              }"
              autocomplete="off"
            />
          </div>
          <div
            class="text-danger col"
            *ngIf="
              (fval.itemRate.touched || fval.itemRate.dirty) &&
              fval.itemRate.errors?.required
            "
          >
            The loan rate is required!
          </div>
        </div>

        <!--request pin if setting interest rate for individual-->
        <div class="form-group text-primary">
          <label for="pin" [ngClass]="fval.pin.valid ? 'text-info' : ''"
            >USER's PIN<i *ngIf="fval.pin.valid" class="material-icons"
              >check_circle</i
            ></label
          >

          <div class="input-group mb-0">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i
                  class="fas fa-lock text-primary mx-auto"
                  style="size: 50px"
                ></i>
              </div>
            </div>
            <input
              type="password"
              formControlName="pin"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  (fval.pin.touched || fval.pin.dirty) && fval.pin.errors
              }"
              placeholder="Enter your PIN"
              autocomplete="off"
            />
          </div>
          <div
            class="text-danger col"
            *ngIf="
              (fval.pin.touched || fval.pin.dirty) && fval.pin.errors?.required
            "
          >
            The PIN is required!
          </div>

          <div
            class="text-danger col"
            *ngIf="
              (fval.pin.touched || fval.pin.dirty) && fval.pin.errors?.maxlength
            "
          >
            Please enter a valid pin!
          </div>
          <div
            class="text-danger col"
            *ngIf="
              (fval.pin.touched || fval.pin.dirty) && fval.pin.errors?.hasNumber
            "
          >
            Only digits are allowed!
          </div>
          <div
            class="text-danger col"
            *ngIf="
              (fval.pin.touched || fval.pin.dirty) && fval.pin.errors?.minlength
            "
          >
            Please enter a valid pin!
          </div>
        </div>

        <div class="d-flex my-3 pt-2 pb-3 mx-auto">
          <ngx-alerts></ngx-alerts>
          <button
            type="submit"
            class="btn btn-info col-5 mx-auto"
            [disabled]="!userForm.valid || !checkedClient?.customerId || loading"
          >
            Save
          </button>
          <button
            type="button"
            class="btn btn-info col-5 mx-auto"
            (click)="revert()"
          >
            Cancel
          </button>
        </div>
        </div>
      </form>
    </div>
  </div>
</div>
<ng-template #template>
  <app-statement-modal
    (close)="getClose($event)"
    [data]="statement"
    [customerName]="checkedClient.customerName"
  >
  </app-statement-modal>
</ng-template>
<ng-template #dataModal>
  <app-data-modal
    (close)="getClose($event)"
    (result)="getResult($event)"
    [dataKind]="selectionKind"
    [data]="selectionData"
    [title]="modalTitle"
  ></app-data-modal>
</ng-template>

